import { Options } from "@components/modules/Table/types";

export default {
    heading: "Discounts"
} as Options<Resources.ClubPromo>